<template>
  <div class="dorm-form" :class="{ sticky: fixedForm }" :style="formOffset">
    <SubpageGallery
      gallery-class="mt-0"
      v-if="cityDetails && cityDetails.images.length > 0"
      :gallery="cityDetails.images"
      :img-count="cityDetails.images.length > 5 ? 5 : 3"
    />
    <Modal2 :active="showModal" @onModalClose="closeModal">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <span class="close" ref="close" v-on:click="closeModal">&times;</span>
          <v-button
            v-if="showErrorMessage"
            class="red fw shadow-none login-box__submit mycursor1"
            :title="apiErrorMessage || 'Lütfen bilgilerinizi kontrol edin!'"
          />
          <h3 class="login-box__title">ÜYE GİRİŞİ</h3>
          <v-input
            ref="input1"
            placeholder="E-mail adresiniz"
            v-model="loginForm.email"
          />
          <label
            for="password"
            v-if="falseEmail"
            class="myValidationText"
            required
            >Geçersiz e-posta formatı!</label
          >
          <label for="password" v-if="emptyEmail2" class="myValidationText"
            >Bu kısım boş geçilemez!</label
          >
          <span class="text-danger"></span>
          <v-input
            ref="input2"
            placeholder="Şifreniz"
            type="password"
            v-model="loginForm.password"
          />
          <label
            for="password"
            v-if="emptyName"
            class="myValidationText"
            required
            >Bu kısım boş geçilemez!</label
          >
          <router-link class="password-forget" to="/sifremi-unuttum">
            Şifremi Unuttum</router-link
          >
          {{ error }}
          <v-button
            class="green fw shadow-none login-box__submit"
            @click.native="login"
            title="GİRİŞ YAP"
          />
          <div class="or">
            <!-- <img src="@/assets/img/logo-colored.svg" alt="yurt yurtlarburada" class="preloader-svg" width="200">'da yeni misiniz? -->
            <p>
              <span class="mycolorBlue1">Yurtlarburada</span
              ><span class="mycolor2a">.com</span>'da yeni misiniz?
            </p>
          </div>
          <v-button
            class="gray fw shadow-none login-box__submit"
            @click.native="register"
            title="KAYIT OL"
          />
        </div>
      </div>
    </Modal2>

    <Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">MESAJINIZ GÖNDERİLDİ!</h2>
          <div class="or">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span>
            </p>
            <p>
              <span class="mycolorBlue"
                >Arkadaşlarımız en yakın zamanda sizinle iletişime
                geçecek.</span
              >
            </p>
          </div>
        </div>
      </div>
    </Modal2>

    <Modal2 :active="apiError.show" @onModalClose="closeApiError">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">Hata!</h2>
          <div class="or">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue"
                >Rezervasyon gerçekleştirilirken bir sorun oluştu.</span
              >
            </p>
            <br />
            <p>
              <span class=" text-muted">{{
                apiError.message || 'Bilinmeyen bir hata'
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </Modal2>

    <div class="dorm-form-buttons">
      <div class="dorm-form-buttons__left">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[
            {
              'white blue': !isFavorite,
              'green white': isFavorite
            }
          ]"
          icon="icon-heart"
          icon-position="left"
          :title="isFavorite ? 'Favori Listemden Çıkar' : 'Favori Listeme Ekle'"
          @click.native="setFavorite"
        />
      </div>
      <div class="dorm-form-buttons__right">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[
            {
              'white blue': !isShare,
              'green white': isShare
            }
          ]"
          icon="icon-share"
          icon-position="left"
          title="Paylaş"
          @click.native="showShare"
        />
      </div>
    </div>
    <social-sharing
      v-if="showShareButtons"
      :url="this.url"
      :title="this.name"
      :description="this.description"
      :quote="this.name"
      hashtags="yurtlarburada"
      :twitter-user="this.twitter_user"
      inline-template
    >
      <div class="dorm-form__wrp mysharebuttons ">
        <div class="icon-font">
          <network network="facebook">
            <span class="icon-font mybutton">
              <svg-icon type="icon-facebook" />
            </span>
          </network>
          <network network="twitter">
            <span class="icon-font mybutton">
              <svg-icon type="icon-twitter" />
            </span>
          </network>
          <network network="whatsapp">
            <span class="icon-font mybutton ">
              <svg-icon type="icon-whatsapp" />
            </span>
          </network>

          <network network="email">
            <span class="icon-font mybutton">
              <svg-icon type="icon-mail" />
            </span>
          </network>
        </div>
      </div>
    </social-sharing>
    <div>&nbsp;</div>
    <div class="dorm-form__wrp" :style="{ width: formWidth + 'px' }">
      <div v-show="!isMessage">
        <div class="dorm-form-tab">
          <div
            class="dorm-form-tab__item mycolor mycursor1 form-center-title"
            :class="active"
            icon="icon-mail"
          >
            <svg-icon
              type="icon-fiyat-sor"
              style="font-size:30; color:#eb6081;"
            />
            <div class="dorm-form-tab__title">REZERVE ET</div>
          </div>
        </div>
      </div>

      <div class="dorm-form__inner">
        <div class="dorm-form__form">
          <div>
            <div id="my-form" ref="myMessageForm">
              <v-input
                ref="myInput"
                placeholder="Ad Soyad"
                v-model="user.name"
              />
              <label for="password" v-if="emptyName" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <div class="datetime-picker-wrapper">
                <FunctionalCalendar
                  :key="key"
                  v-model="reservation_date"
                  :is-modal="true"
                  :is-date-range="true"
                  :is-separately="true"
                  :is-multiple="true"
                  placeholder="Tarih Seçiniz"
                  date-format="yyyy-mm-dd"
                  :limits="limits"
                  :marked-dates="markedDates"
                  :enabled-dates="availableDays"
                  :disabled-dates="['beforeToday']"
                  :day-names="names.day"
                  :month-names="names.month"
                ></FunctionalCalendar>
              </div>
              <VueInputRestricted
                placeholder="Telefon No"
                v-model="user.phone"
              />
              <label for="phone" v-if="emptyPhone" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <label for="phone" v-if="falsePhone" class="myValidationText"
                >Telefon numarası 0 ile başlamalıdır!</label
              >
              <label for="phone" v-if="shortPhone" class="myValidationText"
                >Telefon numarası 11 hane olmalıdır!</label
              >
              <!-- <div :data-validation="emailValidation" data-validation-text="* Girilen e-mail geçersiz." > -->
              <v-input
                type="text"
                placeholder="E-Posta Adresi"
                v-model="user.email"
              />
              <label for="password" v-if="falseEmail" class="myValidationText"
                >Geçersiz e-posta formatı!</label
              >
              <label for="password" v-if="emptyEmail" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <v-input
                type="number"
                placeholder="Kişi Sayısı"
                v-model="user.adult"
              />
              <div class="dorm-form-price">
                <div class="dorm-form-price__title">Toplam Ücret</div>
                <div class="dorm-form-price__price" v-if="prices.total !== 0">
                  {{ prices.total }} TL
                  <small>{{ prices.night }} gece {{ prices.day }} gün</small>
                </div>
                <div v-else>
                  <div class="text-muted">Fiyat almak için tarih seçiniz</div>
                </div>
              </div>
            </div>
            <v-button
              class="red fw mt-15 dorm-form__submit"
              title="REZERVE ET"
              v-if="messageEnabled"
              @click.native="submitForm()"
            />
            <v-button
              class="red fw mt-15 dorm-form__submit"
              title="YÜKLENİYOR..."
              v-if="!messageEnabled"
            />
          </div>

          <div class="or">
            <div class="or__title">VEYA</div>
          </div>

          <v-button
            v-show="!isNumberShow"
            class="gray icon-left fw dorm-form__button"
            icon="icon-headphone"
            icon-position="left"
            title="YURDU ARA"
            @click.native="showNumber"
          />

          <a v-if="isNumberShow" :href="'tel:' + phone1">
            <v-button
              v-show="isNumberShow"
              class="gray icon-left fw dorm-form__button"
              icon="icon-headphone"
              icon-position="left"
              :title="phone1"
            />
          </a>
          <v-button
            class="green icon-left fw dorm-form__button"
            icon="icon-whatsapp"
            icon-position="left"
            title="YURDA YAZ"
            @click.native="sendWhatsappMessage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal2 from '@/components/Modal2'
import VueInputRestricted from '@/components/VueInputRestricted'
import { SET_TOKEN, SET_USER_INFO } from '@/store/mutations.type'
import axios from 'axios'
import { FunctionalCalendar } from 'vue-functional-calendar'
import SocialSharing from 'vue-social-sharing'
import { mapGetters } from 'vuex'
// import SelectBoxTemp2 from '@/components/SelectBoxTemp2'
export default {
  name: 'DormForm',
  components: {
    SocialSharing,
    Modal2,
    VueInputRestricted,
    FunctionalCalendar
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.name + ' | ' + this.city_name + ' | ' + this.district_name,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.description ? this.description : ''
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords ? this.keywords : ''
        }
      ],
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: window.location.origin + '/' + this.dorm_slug
        }
      ]
    }
  },
  props: {
    fixedForm: Boolean,
    formOffset: Object,
    formWidth: Number,
    currentPrice: [String, Number],
    currentRoom: Object,
    dormId: Number,
    phone1: String,
    phoneForMessage: String,
    name: String,
    description: String,
    district_name: String,
    city_name: String,
    keywords: String,
    dorm_slug: String,
    dates: Array,
    room: Object
  },
  data() {
    return {
      key: 0,
      messageEnabled: true,
      facultyEnabled: false,
      page_url: '',
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      reservation_date: null,
      emptyFaculty: false,
      description1: null,
      name1: null,
      apiError: {
        show: false,
        message: null
      },
      // first_name: null,
      // last_name: null,
      twitter_user: null,
      universities: null,
      faculties: null,
      url: '',
      showModal: false,
      favorites: [],
      email: '',
      password: '',
      showShareButtons: false,
      isFavorite: false,
      isShare: false,
      isNumberShow: false,
      isMessage: false,
      hasError: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      apiErrorMessage: '',
      errorMessageTemplate: 'Lütfen tüm alanları doğru şekilde doldurun.',
      errorMessage: 'Lütfen tüm alanları doğru şekilde doldurun.',
      user: {
        adult: 1
      },
      /*       messageForm: {
          dorm_id: '',
          name: '',
          email: '',
          university_id: '',
          faculty_id: '',
          phone: '',
          university_name: 'Üniversite Seç',
          faculty_name: 'Fakülte Seç'
        }, */
      loginForm: {
        email: null,
        password: null
      },
      reservationForm: {
        dorm_id: null,
        name: '',
        phone: '',
        room_type_id: 0
      },
      tabs: [
        {
          id: 0,
          title: 'DÖNEMLİK',
          active: true
        },
        {
          id: 1,
          title: 'GÜNLÜK',
          active: false
        }
      ],
      roomTypes: [
        {
          name: '2 Kişilik Lüks',
          value: 'two'
        },
        {
          name: '3 Kişilik Lüks',
          value: 'three'
        },
        {
          name: '4 Kişilik Normal',
          value: 'four'
        },
        {
          name: '5 Kişilik Fakir Odası',
          value: 'five'
        }
      ],
      pricePerDay: 90,
      pricePerMonth: 290,
      priceTypeMonth: true,
      names: {
        day: ['Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts', 'Pzr'],
        month: [
          'Ocak',
          'Şubat',
          'Mart',
          'Nisan',
          'Mayıs',
          'Haziran',
          'Temmuz',
          'Ağustos',
          'Eylül',
          'Ekim',
          'Kasım',
          'Aralık'
        ]
      },
      limits: {
        min: this.toString(new Date()),
        max: this.toString(
          new Date(new Date().setDate(new Date().getDate() + 850))
        )
      }
    }
  },
  methods: {
    closeApiError() {
      this.apiError.show = false
    },
    showApiError(msg) {
      this.apiError.show = true
      this.apiError.message = msg
    },
    fixDate(date) {
      let datetime = new Date(date)
      let fixedDate = `${datetime.getFullYear()}-`
      if (datetime.getMonth() + 1 < 10) {
        fixedDate += '0' + (datetime.getMonth() + 1) + '-'
      } else {
        fixedDate += datetime.getMonth() + 1 + '-'
      }
      if (datetime.getDate() < 10) {
        fixedDate += '0' + datetime.getDate()
      } else {
        fixedDate += datetime.getDate()
      }
      return fixedDate
    },
    fixDates(start, end) {
      return {
        start: this.fixDate(start),
        end: this.fixDate(end)
      }
    },
    selectUniversity(opt) {
      this.user.university_id = opt.id
      this.user.university_name = opt.name
      let self = this
      axios
        .get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getFaculties(id) {
      let self = this
      axios.get(`/selected/faculties/${id}`).then(response => {
        self.faculties = response.data
      })
    },
    validateEmail(email) {
      // @eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    getUniversities() {
      let self = this
      axios
        .get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFaculty(opt) {
      this.user.faculty_id = opt.id
      this.user.faculty_name = opt.name
    },
    closeModal() {
      this.showModal = false
    },
    closeModal2() {
      this.showSuccessMessage = false
    },
    register() {
      this.$router.push('/uye-ol')
    },
    login() {
      /*       if (this.validateForm()) {
                  console.log('formValidated');
                  //submit form to backend
              }

        this.validate()
        */
      this.falseEmail = false
      // this.falsePhone = false
      // this.shortPhone = false
      this.emptyName = false
      this.emptyEmail2 = false
      const verifiedMail = this.validateEmail(this.loginForm.email)
      if (!this.loginForm.password) {
        this.emptyName = true
      }
      if (!this.loginForm.email) {
        this.emptyEmail2 = true
      } else if (!this.emptyEmail2 && !verifiedMail) {
        this.falseEmail = true
      }

      if (!this.emptyName && verifiedMail && !this.falseEmail) {
        var self = this
        /*       if(!this.valid) {
          // this.email = 'Mail giriniz'
          this.$refs.input1.value = 'Mail giriniz'
        } */
        // if(this.valid) {
        axios
          .post(`/user/login`, {
            email: this.loginForm.email,
            password: this.loginForm.password
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.$store.commit(SET_USER_INFO, response.data.user)
              self.$store.commit(SET_TOKEN, response.data.token)
              axios.defaults.headers.common['Authorization'] =
                'Bearer ' + response.data.token
              this.closeModal()
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail1', response.data.user.email)
              window.localStorage.setItem(
                'username1',
                response.data.user.first_name +
                  ' ' +
                  response.data.user.last_name
              )
              window.localStorage.setItem(
                'first_name1',
                response.data.user.first_name
              )
              window.localStorage.setItem(
                'last_name1',
                response.data.user.last_name
              )
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem('type_id', response.data.user.type_id)
              if (response.data.user.university_id) {
                window.localStorage.setItem(
                  'university_id1',
                  response.data.user.university_id
                )
              } else {
                window.localStorage.setItem('university_id1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem(
                  'faculty_id1',
                  response.data.user.faculty_id
                )
              } else {
                window.localStorage.setItem('faculty_id1', '')
              }

              if (response.data.user.university_name) {
                window.localStorage.setItem(
                  'university_name1',
                  response.data.user.university_name
                )
              } else {
                window.localStorage.setItem('university_name1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem(
                  'faculty_name1',
                  response.data.user.faculty_name
                )
              } else {
                window.localStorage.setItem('faculty_name1', '')
              }
              self.user = response.data.user
              self.isFavorite = true
              axios.post(`/site/dorm/favorite/${self.dormId}`, {})

              // self.$router.push(self.$route.params.slug + '-y-' + self.dormId)
              // refresh yapmadan bilglieri formda güncellemiyor, sebebi anlaışamadı
              window.open(
                window.location.origin +
                  '/' +
                  self.$route.params.slug +
                  '-y-' +
                  self.dormId,
                '_self'
              )

              // document.cookie = "username=response.data.user.first_name; expires=Thu, 18 Dec 2019 12:00:00 UTC";
            } else {
              self.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
            }
          })
      }
    },
    sendWhatsappMessage() {
      axios.post(`site/dorm/view_number_button/${this.dormId}`, {
        type: 'whatsapp'
      }) // this.isMessage = true
      window.open(
        'https://wa.me/' +
          this.phoneForMessage +
          '?text=Merhaba,%20Size%20yurtlarburada.com%20arac%C4%B1l%C4%B1%C4%9F%C4%B1yla%20ula%C5%9F%C4%B1yorum.%20Yurdunuz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum',
        '_blank'
      )
    },
    showShare() {
      this.isShare = !this.isShare
      this.showShareButtons = !this.showShareButtons
    },
    setFavorite() {
      if (this.isLogin === '') {
        this.showModal = true
        // var modal = this.$refs.myModal
        // modal.style.display = "block"
      } else {
        if (!this.isFavorite) {
          axios.post(`/site/dorm/favorite/${this.dormId}`, {})
        } else {
          axios.post(`/site/dorm/unfavorite/${this.dormId}`, {})
        }
        this.isFavorite = !this.isFavorite
      }
    },
    changePrice(index) {
      this.tabs.forEach(item => {
        item.active = false
      })
      this.tabs[index].active = true
      this.priceTypeMonth = !this.priceTypeMonth
    },
    handleInput(value, status) {
      if (status === 'error') {
        this.hasError = true
      }
    },
    showNumber() {
      this.isNumberShow = true
      axios.post(`site/dorm/view_number_button/${this.dormId}`, {
        type: 'normal'
      })
    },
    setOffsets() {
      this.formWidth = this.$refs.dormForm.offsetWidth
    },
    handleScroll() {
      let windowY = window.scrollY
      let contentOffsetTop = this.$refs.dormContent.offsetTop
      let contentOffsetLeft =
        this.$refs.dormContent.offsetLeft + this.$refs.dormRight.offsetLeft

      if (windowY >= contentOffsetTop) {
        this.fixedForm = true
        this.formOffset.left = contentOffsetLeft + 'px'
        this.formOffset.top = 10 + 'px'
      } else {
        this.fixedForm = false
        this.formOffset.left = 0
        this.formOffset.top = 23 + 'px'
      }
    },
    submitForm() {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      const verifiedMail = this.validateEmail(this.user.email)
      if (!this.user.email) {
        this.emptyEmail = true
      } else if (this.user.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.user.name) {
        this.emptyName = true
      }
      if (!this.user.phone) {
        this.emptyPhone = true
      }

      if (this.user.phone && !this.user.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (
        this.user.phone &&
        !this.falsePhone &&
        this.user.phone.length !== 11
      ) {
        this.shortPhone = true
      }

      if (
        !this.emptyName &&
        !this.emptyEmail &&
        !this.falseEmail &&
        verifiedMail &&
        !this.emptyPhone &&
        !this.falsePhone &&
        !this.shortPhone
      ) {
        this.user.dorm_id = this.$route.params.id
        this.showErrorMessage = false
        let self = this
        this.messageEnabled = false
        const dates = this.fixDates(
          this.reservation_date.dateRange.start,
          this.reservation_date.dateRange.end
        )
        axios
          .post(`/site/room/reservation`, {
            name: this.user.name,
            email: this.user.email,
            phone: this.user.phone,
            room_id: this.room.id,
            start_date: dates.start,
            end_date: dates.end,
            capacity: this.user.adult
          })
          .then(response => {
            this.messageEnabled = true
            console.log(response)
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            } else {
              this.showApiError(response.data.message)
            }
          })
          .catch(error => {
            if (error.response) {
              this.showApiError(error.response.data.message)
            }
          })
      }
    },
    submitReservationForm() {
      this.reservationForm.dorm_id = this.$route.params.id
      if (
        this.reservationForm.name === '' ||
        this.reservationForm.phone === '' ||
        this.reservationForm.room_type_id === ''
      ) {
        this.showErrorMessage = true
        this.errorMessage = this.errorMessageTemplate
      } else {
        this.showErrorMessage = false
        let self = this
        const dormId = window.localStorage.getItem('dormid')
        axios
          .post(`/site/dorm/reservation/${dormId}`, {
            data: this.reservationForm
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
            }
          })
      }
    },
    getFavorites() {
      let self = this
      axios
        .get(`/user/favorites`)
        .then(response => {
          self.favorites = response.data.favorites
          let isFavorite = self.favorites.find(function(dorm) {
            return dorm.id === window.localStorage.getItem('dormid')
          })
          if (isFavorite) {
            this.isFavorite = true
          }
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    calculatePriceAndDays(startDate, endDate, dailyPrice, adult) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      const millisecondsPerDay = 24 * 60 * 60 * 1000
      const totalDays = Math.round(Math.abs((end - start) / millisecondsPerDay))
      return {
        day: totalDays - 1,
        total: totalDays * dailyPrice * adult,
        night: totalDays
      }
    },
    loaded() {
      this.key++
    },
    getFormData() {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      if (
        !window.localStorage.getItem('university_id') ||
        window.localStorage.getItem('university_id') === '' ||
        window.localStorage.getItem('university_id') === 'null' ||
        window.localStorage.getItem('university_id') === 'undefined'
      ) {
      } else {
        this.user.university_id = window.localStorage.getItem('university_id')
        this.getFaculties(window.localStorage.getItem('university_id'))
      }
      this.user.university_id = window.localStorage.getItem('university_id1')
      this.user.faculty_id = window.localStorage.getItem('faculty_id1')
      this.dormId = window.localStorage.getItem('dormid')
      this.url =
        'https://yurtlarburada.com/' + window.localStorage.getItem('slug')
      this.twitter_user = this.first_user + this.last_user
    }
  },
  mounted() {
    if (this.isLogin) {
      this.getFavorites()
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'first_name',
      'last_name',
      'mail1',
      'phone',
      'university_name',
      'faculty_name',
      'university_id',
      'faculty_id'
    ]),
    availableDays() {
      return this.dates.filter(d => !!d.data).map(d => d.str)
    },
    markedDates() {
      const res = this.dates
        .filter(d => !!d.data)
        .map(d => ({
          date: d.str,
          class: +d.remainingCapacity === 0 ? 'full-reserved' : 'available'
        }))
      this.loaded()
      return res
    },
    prices() {
      if (this.user.adult < 0) return { total: 0 }
      if (!this.room) return { total: 0 }
      let startDate = null
      let endDate = null
      if (this.reservation_date !== null) {
        startDate = this.reservation_date.dateRange.start
        endDate = this.reservation_date.dateRange.end
      }
      if (!startDate || !endDate) {
        return { total: 0 }
      }
      return this.calculatePriceAndDays(
        startDate,
        endDate,
        this.room.daily_price,
        this.user.adult
      )
    }
  },
  created() {
    // this.selectUniversity({id:4, name: 'Kocaeli Üniversitesi'})
    this.getUniversities()
    // this.getFormData()

    this.page_url =
      window.location.origin + '/' + window.localStorage.getItem('url')
    this.user.name = this.first_name + ' ' + this.last_name
    this.user.email = this.mail1
    this.user.phone = this.phone
    this.user.university_name = this.university_name
    this.user.faculty_name = this.faculty_name
    this.user.university_id = window.localStorage.getItem('university_id1')
    this.user.faculty_id = window.localStorage.getItem('faculty_id1')

    var self = this
    if (this.university_id !== '') {
      axios.get(`/selected/faculties/${this.university_id}`).then(response => {
        self.faculties = response.data
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/components/dorm-form';
.myColor {
  background-color: #ec689e;
  color: red;
  font-size: 36;
}

modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  height: 45%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.mycolorBlue {
  color: #4b5ba4;
  font-weight: bold;
}
.mycolorBlue1 {
  color: #4b5ba4;
  font-weight: bold;
}
.mycolor2a {
  color: #17d9ae;
  font-weight: bold;
}

.mybutton {
  display: inline-block !important;
  padding: 10px 0;
}

.myborder {
  border-left: 1px solid #ddd;
  height: 30px;
  padding-left: 3px;
}

.mysharebuttons {
  cursor: pointer;
  margin-top: 18px;
}

.mysharebuttons > .icon-font {
  font-size: 18px;
  color: #9198b2;
  width: 100%;
}

.mysharebuttons .icon-font > span {
  width: 33%;
  display: block;
  text-align: center;
  border-right: 1px solid #ddd;
  &:hover {
    .mybutton {
      color: #eb6081;
    }
  }
}

.mysharebuttons .icon-font > span:last-child {
  border-right: none;
}

.mycolorshare {
  color: #4b5ba4;
}
.mycursor1 {
  cursor: default;
}
.mycursorPointer {
  cursor: pointer;
}
.myValidationText {
  font-size: 13px;
  color: #dc3545;
}

.form-center-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.datetime-picker-wrapper {
  border-bottom: 1px solid #dadce2;
  padding-bottom: 3px;
  .vfc-multiple-input {
    border: none;
    display: flex;
    input {
      border: none;
      width: unset;
      &:first-child {
        border-right: 1px solid #dadce2;
      }
    }
  }
  .vfc-main-container.vfc-modal {
    width: 95%;
    left: 50%;
    transform: translateX(-50%);
  }
  .vfc-week .vfc-day span.vfc-span-day.vfc-today {
    background-color: unset;
  }

  .vfc-week .vfc-day span.vfc-span-day:not(.vfc-disabled) {
    &.available {
      background-color: #23daa9 !important;
      color: #fff;
    }
    &.full-reserved {
      background-color: #eb6081 !important;
      color: #fff;
    }
  }
}
</style>
